import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {
  postShareableCalendarView,
  putShareableCalendarView,
} from '../../../services/shareableCalendarViews'

export async function createShareableView(dispatch, data) {
  try {
    dispatch({type: PENDING})
    let response = await postShareableCalendarView(data)
    dispatch({type: SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Create Calendar View Failed: ${data}`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}

export async function updateShareableView(dispatch, data) {
  try {
    dispatch({type: PENDING})
    let response = await putShareableCalendarView(data)
    dispatch({type: SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Update Calendar View Failed: ${data}`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
